var exports = {
  "filters-layout": "x24da60e8--bbd2d4--filters-layout",
  "desktop": "x24da60e8--bbd2d4--desktop",
  "filters": "x24da60e8--bbd2d4--filters",
  "filter": "x24da60e8--bbd2d4--filter",
  "header": "x24da60e8--bbd2d4--header",
  "bottom-filters": "x24da60e8--bbd2d4--bottom-filters",
  "tags": "x24da60e8--bbd2d4--tags",
  "control": "x24da60e8--bbd2d4--control",
};

module.exports = exports;
